export default __webpack_public_path__ + "static/media/Profile_Img.e20e5003.jpeg";